.marquee {
  overflow-x: auto;
  overflow-y: hidden;
  cursor: grab;
  scrollbar-width: none;
  pointer-events: none;
  /*  -webkit-mask-image: linear-gradient(
    90deg,
    transparent,
    #000 6%,
    #000 94%,
    transparent
  );
  mask-image: linear-gradient(
    90deg,
    transparent,
    #000 6%,
    #000 94%,
    transparent
  ); */

  &.draggable {
    pointer-events: all;
  }
}

.track {
  display: flex;
  width: max-content;
  gap: 1.5rem;
}

.children {
  display: flex;
  gap: 1.5rem;
}
